import React, { useState, useEffect, useContext } from "react";

import FirebaseOrder from "./FirebaseOrder";
import {fs} from '../../firebase'
import { getFirestore,doc,getDoc } from 'firebase/firestore';
import {getAuth} from "firebase/auth";
import { getUserPhoneNumber } from '../../utils/userUtils';
import { API_PROXY_BASE } from '../../config/api';
import { LocalizationContext } from "../../localization/LocalizationContext";

const AddTable = ({ totalPrice, selectedProducts, productQuantities }) => {
    const { translations } = useContext(LocalizationContext);
    const [recipientName, setRecipientName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [selectedOrgId, setSelectedOrgId] = useState("");
    const [selectedSectionId, setSelectedSectionId] = useState("");
    const [organizations, setOrganizations] = useState([]);
    const [sections, setSections] = useState([]);
    const [deliveryTimeOption, setDeliveryTimeOption] = useState('asap');
    const [deliveryDateTime, setDeliveryDateTime] = useState('');
    const [personsCount, setPersonsCount] = useState(1);
    const [comment, setComment] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('online');
    const[selectedTableId,setSelectedTableId] = useState('');
    const [token, setToken] = useState('');

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const res = await fetch(`${API_PROXY_BASE}/access_token`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                });

                const data = await res.json();
                if (data?.token) {
                    setToken(data.token);
                } else if (data?.correlationId) {
                    setToken(data.correlationId);
                } else {
                    throw new Error('Токен не получен');
                }
            } catch (err) {
                console.error('Ошибка при получении токена:', err);
            }
        };

        fetchToken();
    }, []);

    useEffect(() => {
        if (!token) return;

        const fetchOrganizations = async () => {
            try {
                const res = await fetch(`${API_PROXY_BASE}/organizations`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        organizationIds: [],
                        returnAdditionsInfo: true,
                        includeDisabled: false
                    })
                });

                const data = await res.json();

                if (Array.isArray(data.organizations)) {
                    setOrganizations(data.organizations);
                } else {
                    console.error("Неверный формат данных организаций:", data);
                }
            } catch (err) {
                console.error('Ошибка при получении организаций:', err);
            }
        };

        fetchOrganizations();
    }, [token]);

    useEffect(() => {
        if (organizations.length === 0 || !selectedProducts) return;

        const allProducts = Array.isArray(selectedProducts)
            ? selectedProducts
            : Object.values(selectedProducts).flat();

        if (allProducts.length === 0) return;

        const uniqueOrgIds = [...new Set(allProducts.map(p => p.organizationId).filter(Boolean))];

        if (uniqueOrgIds.length === 1 && uniqueOrgIds[0]) {
            setSelectedOrgId(uniqueOrgIds[0]);
            fetchSections(uniqueOrgIds[0]);
        }
    }, [organizations, selectedProducts]);


    const fetchSections = async (orgId) => {
        if (!orgId || !token) return;

        const visitDate = new Date().toISOString();

        try {
            // 1. Получаем terminalGroupId
            const terminalRes = await fetch(`${API_PROXY_BASE}/terminalgroups`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ organizationIds: [orgId] }),
            });

            const terminalData = await terminalRes.json();
            const terminalGroupId = terminalData?.terminalGroups?.[0]?.items?.[0]?.id;

            if (!terminalGroupId) {
                console.warn("TerminalGroupId не найден для организации", orgId);
                return;
            }

            // 2. Запрашиваем секции
            const sectionRes = await fetch(`${API_PROXY_BASE}/reserve/available_restaurant_sections`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    accessToken: token,
                    organizationId: orgId,
                    terminalGroupId,
                    visitDate
                })
            });

            const data = await sectionRes.json();

            // Исключаем WOLT и GLOVO (без учёта регистра)
            const allowedSections = (data.restaurantSections || []).filter(
                sec => !["wolt", "glovo"].includes(sec.name?.toLowerCase())
            );

            // Сохраняем столики вместе с их секциями
            const tablesWithSection = allowedSections.flatMap(sec =>
                (sec.tables || []).map(table => ({
                    ...table,
                    sectionName: sec.name || "Без секции"
                }))
            );

            setSections(tablesWithSection);

        } catch (err) {
            console.error("Ошибка при получении секций", err);
        }
    };

    const handleOptionChange = (e) => {
        setDeliveryTimeOption(e.target.value);
    };

    const handleDateTimeChange = (e) => {
        setDeliveryDateTime(e.target.value);
    };
    useEffect(() => {
        const savedTableId = localStorage.getItem('selectedTableId');
        if (savedTableId) {
            setSelectedTableId(savedTableId);
        }
        console.log(selectedTableId)
    }, []);
    const handlePersonsChange = (delta) => {
        setPersonsCount(prev => Math.max(1, prev + delta));
    };

    const handlePaymentChange = (e) => {
        setPaymentMethod(e.target.value);
    };

    const orderReceipt = "table";
    useEffect(() => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            setRecipientName(user.displayName || '');

            const fs = getFirestore();
            const userDocRef = doc(fs, "users", user.uid);

            getDoc(userDocRef)
                .then((docSnap) => {
                    if (docSnap.exists()) {
                        const userData = docSnap.data();
                        setPhoneNumber(getUserPhoneNumber(userData) || '');
                    }
                })
                .catch((error) => {
                    console.error("Error fetching user document:", error);
                });
        }
    }, []);
    return (
        <div className="add-delivery-container">

            <input
                type="text"
                value={recipientName}
                onChange={(e) => setRecipientName(e.target.value)}
                placeholder={translations.deliveryPage?.RecipientName || 'Recipient Name'}
                className="delivery-input"
            />
            <input
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder={translations.deliveryPage?.PhoneNumber || 'Phone Number'}
                className="delivery-input"
            />

            <select
                value={selectedOrgId}
                onChange={(e) => {
                    const newOrgId = e.target.value;
                    setSelectedOrgId(newOrgId);
                    setSelectedSectionId(""); // сбросить выбранную секцию
                    fetchSections(newOrgId);  // запрашиваем секции по новой организации
                }}
                className="delivery-input"
            >
                <option value="">{translations.deliveryPage?.selectRestaurant || 'Select a restaurant'}</option>
                {organizations.map(org => (
                    <option key={org.id} value={org.id}>{org.name}</option>
                ))}
            </select>


            <select
                value={selectedTableId}
                onChange={(e) => {
                    const selectedId = e.target.value;
                    setSelectedTableId(selectedId);
                    localStorage.setItem('selectedTableId', selectedId);
                }}
                className="delivery-input"
                disabled={!sections.length}
            >
                <option value="">{translations.deliveryPage?.selectTable || 'Choose a table'}</option>
                {sections.map(table => (
                    <option key={table.id} value={table.id}>
                        {`${table.sectionName} — ${translations.deliveryPage?.tableLabel || 'Table'} №${table.number}`}
                    </option>
                ))}
            </select>


            <div className={'address-input-container'}>
                <div className="delivery-time-options">
                    <label className="switch-option">
                        <input
                            type="radio"
                            name="deliveryTime"
                            value="asap"
                            checked={deliveryTimeOption === 'asap'}
                            onChange={handleOptionChange}
                            className="switch-input"
                        />
                        <span className="switch-slider"></span>
                        <span className="switch-text">{translations.deliveryPage?.AsSoonAsPossible || 'As soon as possible'}</span>
                    </label>

                    <label className="switch-option">
                        <input
                            type="radio"
                            name="deliveryTime"
                            value="scheduled"
                            checked={deliveryTimeOption === 'scheduled'}
                            onChange={handleOptionChange}
                            className="switch-input"
                        />
                        <span className="switch-slider"></span>
                        <span className="switch-text">{translations.deliveryPage?.AtScheduledTime || 'At a specific time'}</span>
                    </label>
                </div>

                {deliveryTimeOption === 'scheduled' && (
                    <div className="datetime-container" style={{ marginTop: '15px' }}>
                        <input
                            type="datetime-local"
                            value={deliveryDateTime}
                            onChange={handleDateTimeChange}
                            className="datetime-input"
                            min={new Date().toISOString().slice(0, 16)}
                        />
                    </div>
                )}
            </div>

            <div className="last-delivery-block">
                <div className="persons-count-container">
                    <div className="Sposob-dostavki">{translations.deliveryPage?.NumberOfPersons || 'Number of People'}</div>
                    <div className="counter-control">
                        <button className="counter-btn minus" onClick={() => handlePersonsChange(-1)}>-</button>
                        <span className="counter-value">{personsCount}</span>
                        <button className="counter-btn plus" onClick={() => handlePersonsChange(1)}>+</button>
                    </div>
                </div>

                <div className="comment-container">
                    <div className="Sposob-dostavki">{translations.deliveryPage?.commentForVenue || 'Comment for the Venue'}</div>
                    <textarea
                        className="comment-textarea"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder={translations.deliveryPage?.YourWishes || "Your wishes..."}
                    />
                </div>

                <div className="payment-container">
                    <div className="Sposob-dostavki">{translations.deliveryPage?.PaymentMethod || 'Payment Method'}</div>
                    <div className="payment-options">
                        <label className="payment-option">
                            <input
                                type="radio"
                                name="paymentMethod"
                                value="online"
                                checked={paymentMethod === 'online'}
                                onChange={handlePaymentChange}
                            />
                            <span>{translations.deliveryPage?.Online || 'Online'}</span>
                        </label>
                    </div>
                </div>
            </div>

            <FirebaseOrder
                orderData={{
                    orderType: 'dine-in',
                    recipientName,
                    phoneNumber,
                    tableNum: selectedTableId, // тут мы передаём ID выбранной секции как "номер стола"
                    deliveryTime: deliveryTimeOption === 'asap' ? 'Now' : deliveryDateTime,
                    personsCount,
                    comment,
                    paymentMethod,
                }}
                orderReceipt={orderReceipt}
                selectedProducts={selectedProducts}
                productQuantities={productQuantities}
                totalPrice={totalPrice}
            />
        </div>
    );
};

export default AddTable;
